
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 28","data-code":"61593","data-tags":"twitter"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.312 6.375a10.85 10.85 0 01-2.53 2.61c.015.218.015.437.015.656C22.797 16.313 17.719 24 8.437 24c-2.859 0-5.515-.828-7.75-2.266.407.047.797.063 1.22.063 2.359 0 4.53-.797 6.265-2.156a5.056 5.056 0 01-4.719-3.5c.313.047.625.078.953.078.453 0 .906-.063 1.328-.172a5.047 5.047 0 01-4.047-4.953v-.063c.672.375 1.454.61 2.282.64a5.043 5.043 0 01-2.25-4.202c0-.938.25-1.797.687-2.547a14.345 14.345 0 0010.406 5.281 5.697 5.697 0 01-.125-1.156A5.045 5.045 0 0117.734 4c1.453 0 2.766.61 3.688 1.594a9.936 9.936 0 003.203-1.219 5.033 5.033 0 01-2.219 2.781c1.016-.11 2-.39 2.906-.78z","fill":"inherit"}})])
          )
        }
      }
    